/* eslint-disable no-void */
import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { FunctionComponent, useEffect } from 'react';
import styles from './PasswordValidationWIdget.module.scss';

const { Icon } = vp;
type PasswordValidationWidgetProps = {
  password: string;
  onValidate: (isValid: boolean) => void;
};
type FC = FunctionComponent<PasswordValidationWidgetProps>;

const PasswordValidationWidget: FC = ({ password, onValidate }: PasswordValidationWidgetProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.PasswordValidationWidget' });
  const hasCharcters = password.length >= 8;
  const hasNumber = /\d/g.test(password);
  const hasLowerCase = /[a-z]/g.test(password);
  const hasUpperCase = /[A-Z]/g.test(password);
  const hasSpecialCharacter = /[^\w]/g.test(password);
  useEffect(() => {
    onValidate(hasCharcters && hasNumber && hasLowerCase && hasUpperCase && hasSpecialCharacter);
  }, [hasCharcters, hasNumber, hasLowerCase, hasUpperCase, hasSpecialCharacter]);
  return (
    <ul className={styles.passwordRequirments}>
      <li>{t('title')}</li>
      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasUpperCase ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('uppercase')}
      </li>
      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasLowerCase ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('lowercase')}
      </li>
      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasNumber ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('number')}
      </li>
      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasSpecialCharacter ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('specialCharacter')}
      </li>
      <li>
        <Icon
          icon="check"
          size="sm"
          color={hasCharcters ? 'primary-purple' : 'medium-dark'}
          width="auto"
          position="left"
        />{' '}
        {t('length')}
      </li>
    </ul>
  );
};

export default PasswordValidationWidget;
